import { AppointmentType } from '../../constants/appointmentType'
import { useFeatureFlags } from 'hooks/useFeatureFlags'
import { useMemo } from 'react'

const useProviderRecommendationForAppointmentTypes = () => {
  const [
    enableAftercareFollowUpRecommendations,
    enableFollowUpRuleRecommendations,
    enableHearingAidRecommendations,
    enableVideoCareCallRecommendations,
    enableExtendedFollowUpRecommendations,
    enableFinalAppointmentRecommendations,
  ] = useFeatureFlags<boolean>([
    'ENABLE_AFTERCARE_FOLLOW_UP_RECOMMENDATIONS',
    'USE_PRS_FOLLOW_UP_RULE',
    'ENABLE_HEARING_AID_EVALUATION_RECOMMENDATIONS',
    'ENABLE_VIDEO_CARE_CALL_RECOMMENDATIONS',
    'ENABLE_EXTENDED_FOLLOW_UP_RECOMMENDATIONS',
    'ENABLE_FINAL_APPOINTMENT_RECOMMENDATIONS',
  ])

  const appointmentTypeFeatureFlagMap: Partial<Record<AppointmentType, boolean>> = useMemo(
    () => ({
      [AppointmentType.AFTERCARE_FOLLOW_UP]: enableAftercareFollowUpRecommendations,
      [AppointmentType.FOLLOW_UP]: enableFollowUpRuleRecommendations,
      [AppointmentType.HEARING_AID_EVALUATION]: enableHearingAidRecommendations,
      [AppointmentType.VIDEO_CARE_CALL]: enableVideoCareCallRecommendations,
      [AppointmentType.EXTENDED_FOLLOW_UP]: enableExtendedFollowUpRecommendations,
      [AppointmentType.FINAL_APPOINTMENT]: enableFinalAppointmentRecommendations,
    }),
    [
      enableAftercareFollowUpRecommendations,
      enableFollowUpRuleRecommendations,
      enableHearingAidRecommendations,
      enableVideoCareCallRecommendations,
      enableExtendedFollowUpRecommendations,
      enableFinalAppointmentRecommendations,
    ]
  )

  return appointmentTypeFeatureFlagMap
}

export { useProviderRecommendationForAppointmentTypes }
